module.exports = __webpack_public_path__ + "static/4-cbe5731f089d597d62168a7a95c5af11.png";